module.exports = __webpack_public_path__ + "static/media/invoice-icon.01a40118.svg";